export default "__VITE_ASSET__16401176__"